export var competitionsClientStub = {
    searchCompetitions: function() {
        return Promise.resolve({});
    }
};
